import React from 'react'
import styled from 'styled-components'

import { H2 } from '../Typography/Typography'
import theme from '../atoms/theme'
import {
  ContentSetItemContent,
  StyledArrowLinkInContent,
} from '../molecules/contentSetItemEvent'
import ContentSetItemPage from '../molecules/contentSetItemPage'
import { StyledImg } from './contentSet'
import { PageCategoryGroupContentSetContainer } from './pageCategoryGroupContentSet'

const { breakpoints, colours, animation } = theme

export const ContentSetItemStyled = styled.div`
  position: relative;
  background-color: ${colours.light};

  @media only screen and ${breakpoints.fromNormalScreen} {
    flex-basis: 100%;
  }

  h3 {
    transition: color ${animation.defaultLength} ease-in-out;
  }

  &:hover {
    h3 {
      color: ${colours.primary};
    }

    ${StyledArrowLinkInContent} {
      opacity: 1;
    }

    ${StyledImg} {
      picture img {
        transform: scale(1.1);
      }
    }

    ${ContentSetItemContent} {
      transform: translate3d(0, -3rem, 0);
    }
  }
`

const PageCategoryGroupContentSetWrapper = styled.div`
  @media only screen and ${breakpoints.toNormalScreen} {
    flex-direction: column;
  }

  @media only screen and ${breakpoints.fromNormalScreen} {
    display: flex;
    flex-wrap: wrap;
  }
`

type PageCategoryGroupContentSetWithImagesPropTypes = {
  title: string
  nodes: [Queries.ContentfulPage | Queries.ContentfulPageCategory]
  hideTitle: boolean
}

const PageCategoryGroupContentSetWithImages = (
  props: PageCategoryGroupContentSetWithImagesPropTypes,
): JSX.Element => {
  const { title, hideTitle, nodes } = props

  return (
    <PageCategoryGroupContentSetContainer>
      {hideTitle === true ? null : <H2>{title}</H2>}
      <PageCategoryGroupContentSetWrapper>
        {nodes.map((link) => {
          return <ContentSetItemPage key={link.id} data={link} />
        })}
      </PageCategoryGroupContentSetWrapper>
    </PageCategoryGroupContentSetContainer>
  )
}

export default PageCategoryGroupContentSetWithImages
